import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete as MuiAutocomplete, CircularProgress, TextField, } from "@mui/material";
import { identity, merge } from "lodash-es";
import { matchSorter } from "match-sorter";
import React from "react";
export const Autocomplete = ({ value = null, onChange, placeholder, inputLabel, autoFocus, required, error, loading, TextFieldProps, filterOptions, startAdornment, ...props }) => {
    const handleChange = React.useCallback((event, value, reason, details) => {
        onChange(value, event, reason, details);
    }, [onChange]);
    const handleReset = React.useCallback((event) => {
        onChange(null, event);
    }, [onChange]);
    return (_jsx(MuiAutocomplete, { ...props, renderInput: params => {
            return (_jsx(TextField, { ...merge(params, TextFieldProps), placeholder: placeholder, label: inputLabel, autoFocus: autoFocus, required: required, error: Boolean(error), helperText: error, slotProps: {
                    input: {
                        ...params.InputProps,
                        endAdornment: (_jsxs(_Fragment, { children: [loading ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })),
                        startAdornment: startAdornment || params.InputProps?.startAdornment ? (_jsxs(_Fragment, { children: [startAdornment, params.InputProps?.startAdornment] })) : undefined,
                    },
                } }));
        }, value: value, onChange: handleChange, onReset: handleReset, filterOptions: filterOptions ?? identity, loading: loading }));
};
export const getFilterOptions = (keys) => (options, { inputValue }) => {
    return matchSorter(options, inputValue, { keys });
};
export const getFilterStringOptions = (getOptionLabel) => (options, { inputValue }) => {
    if (!getOptionLabel) {
        return matchSorter(options, inputValue);
    }
    // When getOptionLabel is provided, create temporary objects for matching
    const optionsWithLabels = options.map(option => ({
        value: option,
        label: getOptionLabel(option),
    }));
    const filtered = matchSorter(optionsWithLabels, inputValue, {
        keys: ["label"],
    });
    return filtered.map(item => item.value);
};
export const getFilterIncludeOptions = (getOptionLabel) => (options, { inputValue }) => {
    return options.filter(option => {
        const label = getOptionLabel?.(option) ?? option;
        return label
            .toLocaleLowerCase()
            .trim()
            .includes(inputValue.toLocaleLowerCase().trim());
    });
};
//# sourceMappingURL=Autocomplete.js.map